export const API_CONFIG = {
  useMock: import.meta.env.VITE_USE_MOCK === 'true',
  baseUrl: import.meta.env.VITE_API_URL || '/api/v1',
};
